const raw = `hgroup{display:flex;flex-direction:column;}.headline5{margin-top:0.5em}time{display:block;margin-bottom:0.5em;}`;
export default raw;